import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const createDenominationChurch = ({
  denominationId,
  denominationChurchData
}) => {
  return axios.post(
    `/denominations/${denominationId}/denomination-churches`,
    denominationChurchData
  );
};

export const useCreateDenominationChurch = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("denomination-churches");
      setNotification({
        type: "success",
        message: "Church created successfully!"
      });
    },
    ...config,
    mutationFn: createDenominationChurch
  });
};
